import React from "react"
import TransitionLink from "gatsby-plugin-transition-link"
import { StaticImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import styled, { css } from "styled-components"

import theme from "styles/theme"
import { media } from "../styles/media"

const StyledWrap = styled.div`
  width: 100%;
  height: 94px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
  padding: 0 16px;
  box-shadow: 0px 1px 0px #dadada;
  position: relative;
  // a {
  //   width: 25%;
  // }
  ${() =>
    media.tablet(css`
      display: none;
    `)}
`

const StyledLine = styled.span`
  display: block;
  content: "";
  height: 40px;
  width: 1px;
  background: #dadada;
`
const StyledAnimated = styled.span`
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 64px;
  border-radius: 8px;
`

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;

  width: calc(100% / 3 - 10px);
  padding: 10px;
  border-radius: 8px;
  background: ${({ color }) => color};
`

// const TransitionLink = styled(TransitionLink)`
//   .gatsby-image-wrapper {
//     display: flex;
//     align-items: center;
//     width: calc(100% / 3);
//     padding: 10px;
//     height: 64px;
//   }
//   .active {
//     width: 100px;
//     background-color: red;
//   }
// `

const length = 0.4
const delay = 0.3
const setColor = currentPagePathname => {
  switch (currentPagePathname) {
    case "/labo/":
      return theme.colors.primary.pink
    case "/thirty-years/":
      return theme.colors.primary.gray
    case "/bits-of-knowledge/":
      return theme.colors.primary.green
  }
}

const SlideHeader = ({ location }) => {
  const { pathname } = location
  const [isActive, setIsActive] = React.useState(false)

  return (
    <StyledWrap>
      <LinkWrapper
        color={pathname === "/labo/" ? setColor(pathname) : "inherit"}
      >
        {/* <StyledAnimated /> */}
        <TransitionLink
          to="/labo/"
          activeClassName="active"
          exit={{
            length,
            state: {
              nextPage: "labo",
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
          entry={{
            delay,
            length,
            state: {
              prevPage: location.pathname,
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
        >
          <StaticImage
            src="../images/logoLabo.svg"
            alt="食物繊維Labo"
            placeholder="none"
          />
        </TransitionLink>
      </LinkWrapper>
      <StyledLine></StyledLine>
      <LinkWrapper
        color={pathname === "/thirty-years/" ? setColor(pathname) : "inherit"}
      >
        {/* <StyledAnimated color={setColor(pathname)} isActive={isActive} /> */}
        <TransitionLink
          to="/thirty-years/"
          exit={{
            length,
            state: {
              nextPage: "thirtyYears",
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
          entry={{
            delay,
            length,
            state: {
              prevPage: location.pathname,
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
        >
          <StaticImage
            src="../images/logo30.svg"
            alt="食物繊維30年"
            placeholder="none"
          />
        </TransitionLink>
      </LinkWrapper>
      <StyledLine></StyledLine>
      <LinkWrapper
        color={
          pathname === "/bits-of-knowledge/" ? setColor(pathname) : "inherit"
        }
      >
        {/* <StyledAnimated color={setColor(pathname)} isActive={isActive} /> */}
        <TransitionLink
          to="/bits-of-knowledge/"
          exit={{
            length,
            state: {
              nextPage: "bitsOfKnowledge",
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
          entry={{
            delay,
            length,
            state: {
              prevPage: location.pathname,
              x: typeof window !== "undefined" && window.innerWidth,
            },
          }}
        >
          <StaticImage
            src="../images/logoKnow.svg"
            alt="食物繊維の豆知識"
            placeholder="none"
          />
        </TransitionLink>
      </LinkWrapper>
    </StyledWrap>
  )
}

export default SlideHeader
